<template>
<v-app>

<Drawer current_item="menu_dashboard2"></Drawer>
<v-main class="ml-6 mr-6">
    <v-row align="end" justify="space-between">
        <v-col cols="12" md="8" class="text-md-h4 text-h5" align="left">
            {{ $t('Member_Title') }}
            </v-col>
        <v-col cols="12" md="4" align="left">
            <FragmentSelectStation :station_code="$route.params.station_code" @onchange="onStationChange"></FragmentSelectStation>
        </v-col>
    </v-row>

    <v-divider class="mb-6"></v-divider>

    <v-tabs v-model="tab" class="mb-4">
        <v-tab
            v-for="item in tabs"
            :key="item.value"
        >
            {{ item.text }}
        </v-tab>
    </v-tabs>

                    <v-tabs-items v-model="tab">
              <v-tab-item
                v-for="item in tabs"
                :key="item.value"
              >

        <div v-if="item.value=='dashboard'">
            <v-row>
                <v-spacer></v-spacer>
                <v-col cols="11" sm="11" md="11" style="margin-left: 10px;">
                    <v-select v-model="selectedChart" :items="charts" label="Select Chart" 
                    item-text="name"
                    item-value="value" multiple chips>
                    </v-select>
                </v-col>
                <v-spacer></v-spacer>
            </v-row>
                <v-container style="overflow:auto" class="text-center">
                    <v-card v-if="show.c1" class="d-inline-block ma-2" outlined>
                        <v-card-title class="justify-center"><h4>ประเภทผู้ใช้ระบบ 9-MANAD รายสัปดาห์</h4></v-card-title>
                        <v-divider></v-divider>
                        <v-card-subtitle>
                            <v-row>
                            <v-col>
                                <DatePicker label='ตั้งแต่วันที่' :date='startDate'></DatePicker>
                            </v-col>
                            <v-col>
                                <DatePicker label='ถึงวันที่' :date='startDate'></DatePicker>
                            </v-col>
                            </v-row>
                        </v-card-subtitle>
                        <v-divider></v-divider>
                    <BarChart :data="barData"></BarChart>
                    </v-card>
                    <v-card v-if="show.c2" class="d-inline-block ma-2" outlined>
                        <v-card-title class="justify-center"><h4>ประเภทผู้ใช้ระบบ 9-MANAD โดยเฉลี่ย</h4></v-card-title>
                        <v-divider></v-divider>
                        <v-card-subtitle>
                            <v-row>
                            <v-col>
                                <v-select
                                    :items="months"
                                    label="ข้อมูลของเดือน">
                                </v-select>
                            </v-col>
                            </v-row>
                        </v-card-subtitle>
                        <v-divider></v-divider>
                        <PieChart :data="pieData"></PieChart>
                    </v-card>
                    <v-card v-if="show.c3" class="d-inline-block ma-2" outlined>
                        <v-card-title class="justify-center"><h4>การตอบสนองการนัดหมาย รายสัปดาห์</h4></v-card-title>
                        <v-divider></v-divider>
                        <v-card-subtitle>
                            <v-row>
                            <v-col>
                                <DatePicker label='ตั้งแต่วันที่' :date='startDate'></DatePicker>
                            </v-col>
                            <v-col>
                                <DatePicker label='ถึงวันที่' :date='startDate'></DatePicker>
                            </v-col>
                            </v-row>
                        </v-card-subtitle>
                        <v-divider></v-divider>
                        <LineChart :data="lineData"></LineChart>
                    </v-card>
                    <v-card v-if="show.c4" class="d-inline-block ma-2" outlined>
                        <v-card-title class="justify-center"><h4>สัดส่วนพฤติกรรมผู้ใช้ระบบ 9-MANAD</h4></v-card-title>
                        <v-divider></v-divider>
                        <v-card-subtitle>
                            <v-row>
                            <v-col>
                                <v-select
                                    :items="months"
                                    label="ข้อมูลของเดือน">
                                </v-select>
                            </v-col>
                            </v-row>
                        </v-card-subtitle>
                        <v-divider></v-divider>
                        <PieChart :data="pieData2"></PieChart>
                    </v-card>
                    
                </v-container>
        </div>

        <div v-if="item.value=='reportMember'">
            <ReportMember></ReportMember>
        </div>
        <div v-if="item.value=='reportAppointment'">
            <ReportAppointment></ReportAppointment>
        </div>
        <div v-if="item.value=='reportBooking'">
            <ReportBooking></ReportBooking>
        </div>
        <div v-if="item.value=='reportMemberBehavior'">
            <ReportMemberBehavior></ReportMemberBehavior>
        </div>
        <div v-if="item.value=='reportAppointmentClassify'">
            <ReportAppointmentClassify></ReportAppointmentClassify>
        </div>
        <div v-if="item.value=='data2'">
            <Data2></Data2>
        </div>
        <div v-if="item.value=='appointTrendDashbord'">
            <AppointTrendDashbord></AppointTrendDashbord>
        </div>
        <div v-if="item.value=='memberBehavior'">
            <MemberBehavior></MemberBehavior>
        </div>
        <div v-if="item.value=='staffLog'">
            <StaffLog></StaffLog>
        </div>
        <div v-if="item.value=='memberLog'">
            <TotalMemberLog></TotalMemberLog>
        </div>
    </v-tab-item>
</v-tabs-items>

            
</v-main>
</v-app>
</template>

<script>
import FragmentSelectStation from '@/components/Common/FragmentSelectStation.vue'
import Drawer from '@/components/Drawer.vue'
import DatePicker from '@/components/Common/DatePicker.vue'
import LineChart from './LineChart'
import BarChart from './BarChart'
import PieChart from './PieChart'

import ReportMember from './ReportMember'
import ReportAppointment from './ReportAppointment'
import ReportBooking from './ReportBooking'
import ReportMemberBehavior from './ReportMemberBehavior'
import ReportAppointmentClassify from './ReportAppointmentClassify'
import AppointTrendDashbord from './AppointTrendDashbord'
import MemberBehavior from './MemberBehavior'
import Data2 from './Data2'
import StaffLog from './StaffLog'
import TotalMemberLog from './TotalMemberLog'


import config from '@/../config.js'
import Staff from '@/model/instance/Staff.js'
import axios from 'axios';

export default {
    components: {
        LineChart,
        BarChart,
        PieChart,
        Drawer,
        FragmentSelectStation,
        DatePicker,
        ReportMember,
        ReportAppointment,
        ReportBooking,
        ReportMemberBehavior,
        ReportAppointmentClassify,
        Data2,
        AppointTrendDashbord,
        MemberBehavior,
        TotalMemberLog,
        StaffLog
    },
    watch: {
        selectedChart: function(newVal) {
            this.show = Object.assign({}, this.defaultItem);
            newVal.forEach(element => {
                switch(element) {
                    case 0: this.show.c1 = true; break;
                    case 1: this.show.c2 = true; break;
                    case 2: this.show.c3 = true; break;
                    case 3: this.show.c4 = true; break;
                }
            });
        }
    },
    data: () => ({
        tab : "",
        tabs : [
                {value: 'dashboard', text: 'dashbord'},
                {value: 'reportMember', text: 'สรุปสมาชิก'},
                {value: 'reportAppointment', text: 'สรุปการนัดหมาย'},
                {value: 'reportBooking', text: 'สรุปการจอง'},
                {value: 'reportMemberBehavior', text: 'สรุปพฤติกรรมสมาชิก'},
                {value: 'reportAppointmentClassify', text: 'สรุปข้อมูลการจัดการนัดหมาย'},
                {value: 'data2', text: 'Data2'},
                {value: 'appointTrendDashbord', text: 'แนวโน้มการนัดหมาย'},
                {value: 'memberBehavior', text: 'พฤติกรรมสมาชิก'},
                {value: 'staffLog', text: 'Staff Log'},
                {value: 'memberLog', text: 'Member Log'},
            ],
        lineData: null,
        barData: null,
        pieData: null,
        pieData2: null,
        show: {c1: true, c2: true, c3: false, c4: false},
        startDate: new Date().toISOString().substr(0, 10),
        months: [
            'มกราคม',
            'กุมภาพันธ์',
            'มีนาคม',
            'เมษายน',
            'พฤษภาคม',
            'มิถุนายน',
            'กรกฎาคม',
            'สิงหาคม',
            'กันยายน',
            'ตุลาคม',
            'พฤษจิกายน',
            'ธันวาคม'
        ],
        selectedChart: [0, 1],
        charts: [
            {name: 'จำนวนการนัดหมายรายสัปดาห์', value: 0},
            {name: 'จำนวนการนัดหมายโดยเฉลี่ย', value: 1},
            //{name: 'พฤติกรรมสมาชิกระบบรายสัปดาห์', value: 2},
            //{name: 'สัดส่วนพฤติกรรมสมาชิกระบบ', value: 3}
            ],
        headers: [],
        desserts: []
    }),
    methods: {
        onStationChange(station){
            document.location = station.station_code
        },
        fillLineData() {
            this.lineData = {
                labels: ['Day1', 'Day2', 'Day3', 'Day4', 'Day5', 'Day6', 'Day7'],
                datasets: [
                    {
                        label: 'จำนวนคนที่กดยอมรับนัด',
                        pointBackgroundColor: '#69da63',
                        borderColor: '#69da63',
                        borderWidth: 1,
                        pointBorderColor: '#69da63',
                        backgroundColor: 'transparent',
                        data: [
                            10, 2, 12, 1, 12, 4, 8
                        ]
                    },
                    {
                        label: 'จำนวนคนที่ไม่ได้กดยอมรับนัด',
                        pointBackgroundColor: '#e3f908',
                        borderColor: '#e3f908',
                        borderWidth: 1,
                        pointBorderColor: '#e3f908',
                        backgroundColor: 'transparent',
                        data: [
                            5, 7, 2, 4,  12, 1, 1
                        ]
                    }
                    ,
                    {
                        label: 'จำนวนคนที่กดปฏิเสธนัด',
                        pointBackgroundColor: '#d14242',
                        borderColor: '#d14242',
                        borderWidth: 1,
                        pointBorderColor: '#d14242',
                        backgroundColor: 'transparent',
                        data: [
                            2, 4, 5, 3, 9, 2, 9
                        ]
                    }
                ]

            }
        },
        fillPieData2() {
            this.pieData2 = {
                labels: ['จำนวนคนที่กดยอมรับนัด', 'จำนวนคนที่ไม่ได้กดยอมรับนัด', 'จำนวนคนที่กดปฏิเสธนัด'],
                datasets: [
                    {
                        backgroundColor: ['#4351cb', '#e3f908', '#d14242'],
                        data: [
                            5, 10, 85
                        ]
                    }
                    ]
            }
        },
    },
    mounted : function () {
        var que = this.$store.commit('addLoading')
        var d = new Date()
        d.setHours(d.getHours()+7)
        d.setDate(d.getDate()-1)
        var end_date = d.toISOString().substring(0,10)
        d.setDate(d.getDate()-6)
        var start_date = d.toISOString().substring(0,10)
        axios
        .post(config.api.url.manage.dashboard.get_activatestat,{
            station_code : this.$route.params.station_code
            ,start_date : start_date
            ,end_date : end_date
        },{ headers: Staff.getTokenHeader()}
        ).then(response => {
            console.log(response.data)

            var data = {day1:{status1:0,status2:0,status3:0,status4:0},day2:{status1:0,status2:0,status3:0,status4:0},day3:{status1:0,status2:0,status3:0,status4:0},day4:{status1:0,status2:0,status3:0,status4:0},day5:{status1:0,status2:0,status3:0,status4:0},day6:{status1:0,status2:0,status3:0,status4:0},day7:{status1:0,status2:0,status3:0,status4:0}}
            var labels = []

            this.headers = [{text: '', value: 'label'}]
            for(var i = 1;i<=7;i++){
                var day = d.toISOString().substring(0,10)
                labels.push(day)
                this.headers.push({text: day, value: 'day' + i})

                response.data.filter(d=>{
                    var date = new Date(d.reservation_date)
                    date.setHours(date.getHours()+7)
                    return date.toISOString().substring(0,10) == day
                }).forEach(d=>{
                    data['day' + i]['status' + d.status] = d.cnt
                })

                d.setDate(d.getDate()+1)
            }

            this.barData = {
                labels: labels,
                datasets: [
                    {
                        label: 'จำนวนคนตรงต่อเวลา',
                        backgroundColor: '#4351cb',
                        data: [
                            data.day1.status1 , data.day2.status1 , data.day3.status1 , data.day4.status1 , data.day5.status1 , data.day6.status1 , data.day7.status1
                        ]
                    },
                    {
                        label: 'จำนวนคนมาก่อนเวลา',
                        backgroundColor: '#e5cd6f',
                        data: [
                            data.day1.status2 , data.day2.status2 , data.day3.status2 , data.day4.status2 , data.day5.status2 , data.day6.status2 , data.day7.status2
                        ]
                    },
                    {
                        label: 'จำนวนคนมาหลังเวลา',
                        backgroundColor: '#d2f316',
                        data: [
                            data.day1.status3 , data.day2.status3 , data.day3.status3 , data.day4.status3 , data.day5.status3 , data.day6.status3 , data.day7.status3
                        ]
                    },
                    {
                        label: 'จำนวนคนไม่มาตามนัด',
                        backgroundColor: '#f33558',
                        data: [
                            data.day1.status4 , data.day2.status4 , data.day3.status4 , data.day4.status4 , data.day5.status4 , data.day6.status4 , data.day7.status4
                        ]
                    },
                    ]
            }

            this.pieData = {
                labels: ['จำนวนคนตรงต่อเวลา', 'จำนวนคนมาก่อนเวลา', 'จำนวนคนมาหลังเวลา', 'จำนวนคนไม่มาตามนัด'],
                datasets: [
                    {
                        label: 'จำนวนคนตรงต่อเวลา',
                        backgroundColor: ['#69da63', '#e5cd6f', '#d2f316', '#f33558'],
                        data: [
                            data.day1.status1 + data.day2.status1 + data.day3.status1 + data.day4.status1 + data.day5.status1 + data.day6.status1 + data.day7.status1
                            , data.day1.status2 + data.day2.status2 + data.day3.status2 + data.day4.status2 + data.day5.status2 + data.day6.status2 + data.day7.status2
                            , data.day1.status3 + data.day2.status3 + data.day3.status3 + data.day4.status3 + data.day5.status3 + data.day6.status3 + data.day7.status3
                            , data.day1.status4 + data.day2.status4 + data.day3.status4 + data.day4.status4 + data.day5.status4 + data.day6.status4 + data.day7.status4
                        ]
                    }
                ]
            }

            

            this.desserts = [
            {'label': 'จำนวนคนนัดทั้งหมด',
             'day1_1': this.barData.datasets.reduce((prev,curr)=> prev + curr.data[0],0),
             'day2_1': this.barData.datasets.reduce((prev,curr)=> prev + curr.data[1],0),
             'day3_1': this.barData.datasets.reduce((prev,curr)=> prev + curr.data[2],0),
             'day4_1': this.barData.datasets.reduce((prev,curr)=> prev + curr.data[3],0),
             'day5_1': this.barData.datasets.reduce((prev,curr)=> prev + curr.data[4],0),
             'day6_1': this.barData.datasets.reduce((prev,curr)=> prev + curr.data[5],0),
             'day7_1': this.barData.datasets.reduce((prev,curr)=> prev + curr.data[6],0),
            }]
            this.desserts.push(
                {'label': 'จำนวนคนตรงต่อเวลา',
                'day1_1': this.barData.datasets[0].data[0], 'day1_2': this.desserts[0].day1_1 == 0 ? '0%' : (this.barData.datasets[0].data[0] * 100 / this.desserts[0].day1_1) + '%',
                'day2_1': this.barData.datasets[0].data[1], 'day2_2': this.desserts[0].day2_1 == 0 ? '0%' : (this.barData.datasets[0].data[1] * 100 / this.desserts[0].day1_1) + '%',
                'day3_1': this.barData.datasets[0].data[2], 'day3_2': this.desserts[0].day3_1 == 0 ? '0%' : (this.barData.datasets[0].data[2] * 100 / this.desserts[0].day1_1) + '%',
                'day4_1': this.barData.datasets[0].data[3], 'day4_2': this.desserts[0].day4_1 == 0 ? '0%' : (this.barData.datasets[0].data[3] * 100 / this.desserts[0].day1_1) + '%',
                'day5_1': this.barData.datasets[0].data[4], 'day5_2': this.desserts[0].day5_1 == 0 ? '0%' : (this.barData.datasets[0].data[4] * 100 / this.desserts[0].day1_1) + '%',
                'day6_1': this.barData.datasets[0].data[5], 'day6_2': this.desserts[0].day6_1 == 0 ? '0%' : (this.barData.datasets[0].data[5] * 100 / this.desserts[0].day1_1) + '%',
                'day7_1': this.barData.datasets[0].data[6], 'day7_2': this.desserts[0].day7_1 == 0 ? '0%' : (this.barData.datasets[0].data[6] * 100 / this.desserts[0].day1_1) + '%',
                }
            )
            this.desserts.push(
                {'label': 'จำนวนคนมาก่อนเวลา',
                'day1_1': this.barData.datasets[1].data[0], 'day1_2': this.desserts[0].day1_1 == 0 ? '0%' : (this.barData.datasets[1].data[0] * 100 / this.desserts[0].day1_1) + '%',
                'day2_1': this.barData.datasets[1].data[1], 'day2_2': this.desserts[0].day2_1 == 0 ? '0%' : (this.barData.datasets[1].data[1] * 100 / this.desserts[0].day1_1) + '%',
                'day3_1': this.barData.datasets[1].data[2], 'day3_2': this.desserts[0].day3_1 == 0 ? '0%' : (this.barData.datasets[1].data[2] * 100 / this.desserts[0].day1_1) + '%',
                'day4_1': this.barData.datasets[1].data[3], 'day4_2': this.desserts[0].day4_1 == 0 ? '0%' : (this.barData.datasets[1].data[3] * 100 / this.desserts[0].day1_1) + '%',
                'day5_1': this.barData.datasets[1].data[4], 'day5_2': this.desserts[0].day5_1 == 0 ? '0%' : (this.barData.datasets[1].data[4] * 100 / this.desserts[0].day1_1) + '%',
                'day6_1': this.barData.datasets[1].data[5], 'day6_2': this.desserts[0].day6_1 == 0 ? '0%' : (this.barData.datasets[1].data[5] * 100 / this.desserts[0].day1_1) + '%',
                'day7_1': this.barData.datasets[1].data[6], 'day7_2': this.desserts[0].day7_1 == 0 ? '0%' : (this.barData.datasets[1].data[6] * 100 / this.desserts[0].day1_1) + '%',
                }
            )
            this.desserts.push({'label': 'จำนวนคนมาหลังเวลา',
                'day1_1': this.barData.datasets[2].data[0], 'day1_2': this.desserts[0].day1_1 == 0 ? '0%' : (this.barData.datasets[2].data[0] * 100 / this.desserts[0].day1_1) + '%',
                'day2_1': this.barData.datasets[2].data[1], 'day2_2': this.desserts[0].day2_1 == 0 ? '0%' : (this.barData.datasets[2].data[1] * 100 / this.desserts[0].day1_1) + '%',
                'day3_1': this.barData.datasets[2].data[2], 'day3_2': this.desserts[0].day3_1 == 0 ? '0%' : (this.barData.datasets[2].data[2] * 100 / this.desserts[0].day1_1) + '%',
                'day4_1': this.barData.datasets[2].data[3], 'day4_2': this.desserts[0].day4_1 == 0 ? '0%' : (this.barData.datasets[2].data[3] * 100 / this.desserts[0].day1_1) + '%',
                'day5_1': this.barData.datasets[2].data[4], 'day5_2': this.desserts[0].day5_1 == 0 ? '0%' : (this.barData.datasets[2].data[4] * 100 / this.desserts[0].day1_1) + '%',
                'day6_1': this.barData.datasets[2].data[5], 'day6_2': this.desserts[0].day6_1 == 0 ? '0%' : (this.barData.datasets[2].data[5] * 100 / this.desserts[0].day1_1) + '%',
                'day7_1': this.barData.datasets[2].data[6], 'day7_2': this.desserts[0].day7_1 == 0 ? '0%' : (this.barData.datasets[2].data[6] * 100 / this.desserts[0].day1_1) + '%',
            })
            this.desserts.push({'label': 'จำนวนคนไม่มาตามนัด',
                'day1_1': this.barData.datasets[3].data[0], 'day1_2': this.desserts[0].day1_1 == 0 ? '0%' : (this.barData.datasets[3].data[0] * 100 / this.desserts[0].day1_1) + '%',
                'day2_1': this.barData.datasets[3].data[1], 'day2_2': this.desserts[0].day2_1 == 0 ? '0%' : (this.barData.datasets[3].data[1] * 100 / this.desserts[0].day1_1) + '%',
                'day3_1': this.barData.datasets[3].data[2], 'day3_2': this.desserts[0].day3_1 == 0 ? '0%' : (this.barData.datasets[3].data[2] * 100 / this.desserts[0].day1_1) + '%',
                'day4_1': this.barData.datasets[3].data[3], 'day4_2': this.desserts[0].day4_1 == 0 ? '0%' : (this.barData.datasets[3].data[3] * 100 / this.desserts[0].day1_1) + '%',
                'day5_1': this.barData.datasets[3].data[4], 'day5_2': this.desserts[0].day5_1 == 0 ? '0%' : (this.barData.datasets[3].data[4] * 100 / this.desserts[0].day1_1) + '%',
                'day6_1': this.barData.datasets[3].data[5], 'day6_2': this.desserts[0].day6_1 == 0 ? '0%' : (this.barData.datasets[3].data[5] * 100 / this.desserts[0].day1_1) + '%',
                'day7_1': this.barData.datasets[3].data[6], 'day7_2': this.desserts[0].day7_1 == 0 ? '0%' : (this.barData.datasets[3].data[6] * 100 / this.desserts[0].day1_1) + '%',
            })
            /*{'label': 'จำนวนคนที่กดยอมรับนัด',
             'day1_1': 45, 'day1_2': '5%',
             'day2_1': 45, 'day2_2': '5%',
             'day3_1': 45, 'day3_2': '5%',
             'day4_1': 45, 'day4_2': '5%',
             'day5_1': 45, 'day5_2': '5%',
             'day6_1': 45, 'day6_2': '5%',
             'day7_1': 45, 'day7_2': '5%'
            },
            {'label': 'จำนวนคนที่ไม่ได้กดยอมรับนัด',
             'day1_1': 45, 'day1_2': '5%',
             'day2_1': 45, 'day2_2': '5%',
             'day3_1': 45, 'day3_2': '5%',
             'day4_1': 45, 'day4_2': '5%',
             'day5_1': 45, 'day5_2': '5%',
             'day6_1': 45, 'day6_2': '5%',
             'day7_1': 45, 'day7_2': '5%'
            },
            {'label': 'จำนวนคนที่กดปฏิเสธนัด',
             'day1_1': 45, 'day1_2': '5%',
             'day2_1': 45, 'day2_2': '5%',
             'day3_1': 45, 'day3_2': '5%',
             'day4_1': 45, 'day4_2': '5%',
             'day5_1': 45, 'day5_2': '5%',
             'day6_1': 45, 'day6_2': '5%',
             'day7_1': 45, 'day7_2': '5%'
            }*/
            console.log(data)


            this.$store.commit('finishLoading',que)
        })
        .catch(error => {
            this.$router.push({name:'Error',params:error}) 
        })
    }
}
</script>